import useIsTablet from 'hooks/useIsTablet';
import { useAppSelector } from 'store/hooks';
import { selectShowWalkthroughV6 } from 'reducers/selectors/walkthrough';
export const useShowWalkthroughV6 = () => {
    const isTablet = useIsTablet();
    const showWalkthroughV6Flag = useAppSelector(selectShowWalkthroughV6);
    return !isTablet && showWalkthroughV6Flag;
};
